import { getUpToBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { type NewTheme } from '@vakantiesnl/components/src/styles/themes/zoover/newTheme';
import { type CSSInterpolation } from 'tss-react';

export const cssStyles = (theme: NewTheme): CSSInterpolation => ({
	'.flatpickr-input': { display: 'none' },
	'.flatpickr-calendar, .flatpickr-days': { width: 'auto !important' },
	'.flatpickr-calendar': {
		[getUpToBreakpoint('md')]: {
			bottom: '0 !important',
			top: 'unset !important',
			left: '50% !important',
			right: 'unset !important',
			width: '100% !important',
			transform: 'translateX(-50%)',

			['&.open']: {
				position: 'fixed',
			},

			'.flatpickr-innerContainer': {
				justifyContent: 'center',
			},
		},

		[getUpToBreakpoint('lg')]: {
			'.flatpickr-innerContainer': {
				justifyContent: 'center',
			},
		},

		'&.arrowTop:before, &.arrowTop:after': {
			display: 'none',
		},
		'.flatpickr-weekwrapper .flatpickr-weeks': {
			boxShadow: 'none',
			minWidth: '45px',
			padding: 0,
			background: theme.calendar.cell.background.week,
			fontWeight: theme.weight.regular,
		},
		'.flatpickr-weekwrapper span.flatpickr-day': {
			fontFamily: theme.fontFamily.primary,
			fontSize: theme.fontSize.xSmall,
			color: theme.calendar.cell.foreground.inactive,
			fontWeight: theme.weight.regular,
			'&:hover': {
				color: theme.calendar.cell.foreground.inactive,
				boxShadow: 'none',
			},
		},
		'span.flatpickr-weekday': {
			fontFamily: theme.fontFamily.primary,
			fontSize: theme.fontSize.xxSmall,
			color: theme.calendar.cell.foreground.default,
			fontWeight: theme.weight.semibold,
			padding: `${theme.spacing.xsmall} 0`,
		},
		'.flatpickr-weekwrapper .flatpickr-weekday, .flatpickr-weekwrapper span.flatpickr-day, span.flatpickr-weekday, .flatpickr-day':
			{
				userSelect: 'none',
			},
		'.flatpickr-day': {
			fontFamily: theme.fontFamily.primary,
			fontSize: theme.fontSize.xSmall,
			border: 'none',
			color: theme.calendar.cell.foreground.default,
			fontWeight: theme.weight.regular,
			display: 'flex',
			alignItems: 'center',

			'&.flatpickr-disabled, &.flatpickr-disabled:hover': {
				fontFamily: theme.fontFamily.primary,
				fontSize: theme.fontSize.xSmall,
				color: theme.calendar.cell.foreground.inactive,
				fontWeight: theme.weight.regular,
				background: 'none',
				boxShadow: 'none',
			},

			'&.nextMonthDay:hover, &.nextMonthDay:focus, &.prevMonthDay:hover, &.prevMonthDay:focus, &:hover, &:focus':
				{
					backgroundColor: theme.calendar.cell.background.hover,
					borderRadius: theme.borderRadius.rounded,
					boxShadow: `-2px 0 0 ${theme.calendar.cell.background.hover}, 3px 0 0 ${theme.calendar.cell.background.hover}`,
					color: theme.calendar.cell.default.font,
				},

			'&.selected.startRange + .endRange:not(:nth-of-type(7n+1)), &.endRange.startRange + .endRange:not(:nth-of-type(7n+1)), &.startRange.startRange + .endRange:not(:nth-of-type(7n+1))':
				{
					boxShadow: `-2px 0 0 ${theme.calendar.cell.background.hover}, 3px 0 0 ${theme.calendar.cell.background.hover}`,
				},

			'&.startRange.startRange + .endRange.selected:not(:nth-of-type(7n+1)):not(:hover)': {
				boxShadow: `-2px 0 0 ${theme.calendar.cell.background.selected}, 3px 0 0 ${theme.calendar.cell.background.selected}`,
			},

			'&.selected, &.prevMonthDay.selected, &.nextMonthDay.selected': {
				backgroundColor: theme.calendar.cell.background.selected,
				borderColor: theme.calendar.cell.background.selected,
				borderRadius: theme.borderRadius.rounded,
				boxShadow: `-2px 0 0 ${theme.calendar.cell.background.selected}, 3px 0 0 ${theme.calendar.cell.background.selected}`,
				color: theme.calendar.cell.foreground.selected,
				font: theme.calendar.cell.selected.font,

				'&:hover ,&:focus': {
					backgroundColor: theme.calendar.cell.background.hover,
					boxShadow: `-2px 0 0 ${theme.calendar.cell.background.hover}, 3px 0 0 ${theme.calendar.cell.background.hover}`,
					color: theme.calendar.cell.default.font,
				},

				'&.startRange, &.endRange': {
					backgroundColor: theme.calendar.cell.background.selected,
					boxShadow: `-2px 0 0 ${theme.calendar.cell.background.selected}, 3px 0 0 ${theme.calendar.cell.background.selected}`,

					'&.endRange': {
						backgroundColor: theme.calendar.cell.background.selected,
						boxShadow: `-2px 0 0 ${theme.calendar.cell.background.selected}, 3px 0 0 ${theme.calendar.cell.background.selected}`,
					},

					'&.startRange': {
						backgroundColor: theme.calendar.cell.background.selected,
						boxShadow: `-2px 0 0 ${theme.calendar.cell.background.selected}, 3px 0 0 ${theme.calendar.cell.background.selected}`,
					},
				},
			},

			'&.endRange': {
				backgroundColor: theme.calendar.cell.background.hover,
				borderRadius: `0 ${theme.borderRadius.rounded} ${theme.borderRadius.rounded} 0`,
				boxShadow: `-2px 0 0 ${theme.calendar.cell.background.selected}, 3px 0 0 ${theme.calendar.cell.background.selected}`,
				color: theme.calendar.cell.default.font,

				'&.endRange, &.endRange:hover, &.endRange:focus': {
					backgroundColor: theme.calendar.cell.background.hover,
					borderRadius: `0 ${theme.borderRadius.rounded} ${theme.borderRadius.rounded} 0`,
					boxShadow: `-2px 0 0 ${theme.calendar.cell.background.hover}, 3px 0 0 ${theme.calendar.cell.background.hover}`,
					color: theme.calendar.cell.default.font,
				},
			},

			'&.startRange': {
				backgroundColor: theme.calendar.cell.background.selected,
				borderRadius: `${theme.borderRadius.rounded} 0 0 ${theme.borderRadius.rounded}`,
				color: theme.calendar.cell.foreground.selected,

				'&.startRange, &.startRange:hover, &.startRange:focus': {
					backgroundColor: theme.calendar.cell.background.hover,
					borderRadius: `${theme.borderRadius.rounded} 0 0 ${theme.borderRadius.rounded}`,
					boxShadow: `-2px 0 0 ${theme.calendar.cell.background.hover}, 3px 0 0 ${theme.calendar.cell.background.hover}`,
					color: theme.calendar.cell.default.font,
				},
			},

			'&.inRange, &.nextMonthDay.inRange, &.prevMonthDay.inRange': {
				backgroundColor: theme.calendar.cell.background.selectedDimmed,
				boxShadow: `-2px 0 0 ${theme.calendar.cell.background.selectedDimmed}, 3px 0 0 ${theme.calendar.cell.background.selectedDimmed}`,
				color: theme.calendar.cell.default.font,

				'&:hover': {
					backgroundColor: theme.calendar.cell.background.hover,
					boxShadow: `-2px 0 0 ${theme.calendar.cell.background.hover}, 3px 0 0 ${theme.calendar.cell.background.hover}`,
					color: theme.calendar.cell.default.font,
				},
			},

			'& .flatpickr-disabled, &.flatpickr-disabled:hover, &.prevMonthDay, &.nextMonthDay, &.notAllowed, &.notAllowed.prevMonthDay, &.notAllowed.nextMonthDay':
				{
					fontFamily: theme.fontFamily.primary,
					fontSize: theme.fontSize.xSmall,
					color: theme.calendar.cell.foreground.inactive,
					fontWeight: theme.weight.regular,
					background: 'none',
					border: 'none',
					boxShadow: 'none',
				},
		},
		'.flatpickr-weekdays': {
			height: 'auto',
		},
		'.flatpickr-weekday, .flatpickr-weekwrapper .flatpickr-weekday': {
			lineHeight: theme.lineHeight.spacious,
			color: theme.calendar.cell.foreground.default,
			textTransform: 'capitalize',
		},

		'.flatpickr-months': {
			display: 'grid',
			gridTemplateColumns: '45px 1fr 45px',
			gridTemplateAreas: "'arrowLeft month arrowRight'",

			'.flatpickr-month': {
				height: '100%',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				gridArea: 'month',
			},

			'.flatpickr-prev-month, .flatpickr-next-month': {
				background: theme.calendar.cell.background.default,
				lineHeight: 0,
				height: 'auto',
				width: 'auto',
				position: 'relative',

				svg: {
					fill: 'black',
					width: theme.icon.size.medium,
					height: theme.icon.size.medium,
				},
				'&:hover svg': {
					fill: theme.primary.color.default,
				},

				'&:hover': {
					color: 'black',
				},

				'&.flatpickr-prev-month': {
					gridArea: 'arrowLeft',
				},
				'&.flatpickr-next-month': {
					gridArea: 'arrowRight',
				},
				'&.flatpickr-prev-month, &.flatpickr-next-month': {
					left: 'auto',
					right: 'auto',
				},
			},
		},
		'.flatpickr-current-month': {
			position: 'relative',
			width: 'auto',
			padding: 0,
			left: 'auto',
			height: 'auto',

			'span.cur-month': {
				fontFamily: theme.fontFamily.primary,
				fontSize: theme.fontSize.xSmall,
				color: theme.calendar.cell.foreground.default,
				fontWeight: theme.weight.semibold,
				textTransform: 'capitalize',
				margin: 0,

				'&:hover': {
					background: 'transparent',
				},
			},
		},
	},
	'.flatpickr-calendar.inline': {
		'&&': {
			borderRadius: 'initial',
			boxShadow: 'none',
			background: 'none',
		},
	},
});
